export const environment = {

    production: false,
    base_url: "https://lpz6k13ffbo93mv.astudio.cloud"

};